export default () => window.innerWidth <= '1024';



// WEBPACK FOOTER //
// ./src/utils/isMobile.js